<template>
  <div>
    <a-card v-show="!shrink" :loading="loading" size="small">
      <span slot="title">
        <span>用例目录</span>
        <a style="margin-left: 4px"><a-icon type="sync" @click="getModuleList" /></a>
      </span>
      <span slot="extra">
        <a v-tc="{ name: '添加目录' }" class="handle-menu" @click="addModule(0)"><a-icon type="plus" /> 添加</a>
      </span>
      <a-input-search style="margin-bottom: 8px" allow-clear placeholder="搜索目录名称" @change="onChange" />
      <a-tree v-if="moduleData.length !== 0" ref="tree" block-node :tree-data="moduleData" draggable show-line :expanded-keys.sync="expandedKeys" :auto-expand-parent="autoExpandParent" :selected-keys.sync="selectedKeys" @select="onSelect" @drop="changeModule">
        <a-icon slot="switcherIcon" type="caret-down" />
        <template slot="title" slot-scope="item">
          <span v-if="item.key == -2" class="node-title" style="color: red; font-weight: bold">
            <a-icon type="rest" /> {{ item.name }}<span v-if="item.total > 0" class="node-title_total" style="color: red; font-weight: bold">({{ item.total }})</span>
          </span>
          <span v-else class="node-title">
            {{ item.name }}<span v-if="item.total > 0" class="node-title_total">({{ item.total }})</span>
          </span>
          <span v-if="item.key == -1 || item.key > 0" class="node-action">
            <span v-tc="{ name: '删除目录' }" class="icon-wrap" @click.stop="deleteModule(item)">
              <a-icon type="delete" />
            </span>
            <span v-tc="{ name: '编辑目录' }" class="icon-wrap" @click.stop="editModule(item)">
              <a-icon type="edit" />
            </span>
            <span v-tc="{ name: '添加子目录' }" class="icon-wrap" @click.stop="addModule(item.id)">
              <a-icon type="plus" />
            </span>
          </span>
        </template>
      </a-tree>
      <a-empty v-else description="还没有目录哦">
        <a-button v-tc="{ name: '创建目录' }" type="primary" icon="plus" @click="addModule(0)"> 创建目录 </a-button>
      </a-empty>
    </a-card>
    <div class="shrink" @click="switchShrink">
      <a-icon class="shrink-icon" :type="shrink === false ? 'left' : 'right'" />
    </div>
    <a-modal v-model="visible" :title="`${moduleId ? '编辑' : '添加'}目录`" :confirm-loading="confirmLoading" @ok="onSubmit">
      <a-form-model ref="form" :model="form" :rules="rules" :label-col="{ span: 5 }" :wrapper-col="{ span: 16 }">
        <a-form-model-item label="名称" prop="name">
          <a-input v-model="form.name" />
        </a-form-model-item>
      </a-form-model>
    </a-modal>
  </div>
</template>
<script>
import { moduleList, moduleDelete, moduleAdd, moduleModify, moduleMove } from '@/api/project/case';

export default {
  data() {
    return {
      shrink: false,
      loading: false,
      visible: false,
      confirmLoading: false,
      moduleId: parseInt(this.$route.query.module_id) || null,
      form: {},
      moduleData: [],
      moduleDataCopy: [],
      moduleCases: {},
      checkedModule: [],
      rules: {
        name: []
      },
      searchValue: null,
      projectId: parseInt(this.$route.params.project_id) || null,
      expandedKeys: [],
      autoExpandParent: true,
      selectedKeys: [this.$route.query.module_id ? parseInt(this.$route.query.module_id) : -1]
    };
  },
  computed: {
    fillterModule() {
      return item => {
        return item.title.includes(this.searchValue);
      };
    }
  },
  created() {
    this.getModuleList(true);
  },
  methods: {
    /**
     * 搜索树节点
     * @param {*} value
     * @param {*} treeData
     */
    searchTreeNode(value, treeData) {
      for (let i = treeData.length - 1; i >= 0; i--) {
        const item = treeData[i];
        if (item.children.length === 0 && !item.title.includes(value)) {
          treeData.splice(i, 1);
        } else if (item.children.length > 0) {
          this.searchTreeNode(value, item.children);
          if (item.children.length === 0 && !item.title.includes(value)) {
            treeData.splice(i, 1);
          }
        }
      }
    },
    getTreeDepth(treeData) {
      let depth = 1;
      for (let i = treeData.length - 1; i >= 0; i--) {
        const item = treeData[i];
        if (item.children.length > 0) {
          const tempDepth = this.getTreeDepth(item.children) + 1;
          if (tempDepth > depth) {
            depth = tempDepth;
          }
        }
      }
      return depth;
    },
    onChange(e) {
      const value = e.target.value;
      // let maxDepth = this.getTreeDepth(this.moduleData)
      if (value) {
        // for(let i = maxDepth - 1 ; i >= 0; i--)
        this.searchTreeNode(value, this.moduleData);
      } else {
        this.moduleData = JSON.parse(JSON.stringify(this.moduleDataCopy));
      }
    },
    changeModule({ node, dragNode, dropToGap }) {
      moduleMove({ project_id: this.projectId, target: node.eventKey, module_id: dragNode.eventKey, to_gap: dropToGap }).then(() => {
        this.$message.success('移动成功');
        this.getModuleList();
      });
    },
    listToTree(list, parentId = 0, trashed = false) {
      const menuObj = {};
      const tempArr = [];
      list.forEach(item => {
        let total = this.moduleCases[item.id] || 0;
        if (trashed) {
          total = this.moduleCases[item.id + '-trashed'] || 0;
        }
        const temp = { ...item, total: total, scopedSlots: { title: 'title' }, children: [] };
        tempArr.push(temp);
        menuObj[item.id] = temp;
      });
      let treeData = tempArr.filter(item => {
        if (item.parent_id !== parentId) {
          let father = menuObj[item.parent_id];
          // 父目录被删除，子目录不展示
          if (!father) {
            return false;
          }
          father.children.push(item);
          let total = this.moduleCases[item.id] || 0;
          if (trashed) {
            total = this.moduleCases[item.id + '-trashed'] || 0;
            item.key = 0 - item.key;
          }

          father.total += total;
          if (trashed && father.key > 0) {
            father.key = 0 - father.key;
          }
          // 深度搜索
          while (father.parent_id !== parentId) {
            father = menuObj[father.parent_id];
            if (!father) {
              break;
            }
            total = this.moduleCases[item.id] || 0;
            if (trashed) {
              total = this.moduleCases[item.id + '-trashed'] || 0;
            }
            father.total += total;
            if (trashed && father.key > 0) {
              father.key = 0 - father.key;
            }
          }
          return false;
        }
        return true;
      });
      if (trashed) {
        treeData = treeData.filter(item => {
          this.clearTreeNodeChildren(item);
          return item.total > 0;
        });
      }
      return treeData;
    },
    clearTreeNodeChildren(node) {
      const children = node.children;
      if (children) {
        node.children = node.children.filter(c => c.total > 0);
        for (let i = 0; i < node.children.length; i++) {
          this.clearTreeNodeChildren(node.children[i]);
        }
      }
    },
    onSelect(selectKeys, e) {
      console.log(e.node.dataRef);
      const nodeModuleData = JSON.parse(JSON.stringify(e.node.dataRef));
      this.$emit('select', selectKeys, nodeModuleData);
    },

    editModule(record) {
      this.moduleId = record.id;
      this.form = {
        sort: 0,
        name: record.name,
        parent_id: record.parent_id
      };
      this.visible = true;
    },

    addModule(id = 0) {
      this.form = {
        sort: 0,
        name: null,
        parent_id: id
      };
      this.moduleId = null;
      this.visible = true;
    },

    switchShrink() {
      this.shrink = !this.shrink;
    },

    /**
     * 删除目录
     * @param {*} record
     */
    deleteModule(record) {
      const self = this;
      this.$confirm({
        title: '确认',
        content: `确认要删除「${record.name}」目录吗？`,
        okText: '确定',
        okType: 'danger',
        cancelText: '取消',
        async onOk() {
          moduleDelete({ project_id: self.projectId, id: record.id }).then(() => {
            self.$message.success('删除成功');
            self.getModuleList();
          });
        }
      });
    },

    // 点击提交
    onSubmit() {
      this.utils.trackClick({ name: '保存目录' });
      this.confirmLoading = true;
      this.$refs.form.validate(valid => {
        if (valid) {
          if (this.moduleId === null) {
            // 添加目录
            moduleAdd({ project_id: this.projectId, ...this.form }).then(() => {
              this.visible = false;
              this.confirmLoading = false;
              this.getModuleList();
            });
          } else {
            // 编辑目录
            moduleModify({ id: this.moduleId, project_id: this.projectId, ...this.form }).then(() => {
              this.visible = false;
              this.confirmLoading = false;
              this.getModuleList();
            });
          }
        }
      });
    },

    getModuleList(isInit) {
      this.loading = true;
      moduleList({ project_id: this.projectId })
        .then(res => {
          this.moduleCases = res.data.module_cases;
          const items = JSON.parse(JSON.stringify(res.data.items));
          const children = [
            {
              id: 0,
              key: 0,
              title: '未分配',
              name: '未分配',
              total: this.moduleCases[null] || 0,
              scopedSlots: { title: 'title' },
              children: []
            },
            ...this.listToTree(items)
          ];
          const trashedChildren = [
            {
              id: -3,
              key: -3,
              title: '未分配',
              name: '未分配',
              total: this.moduleCases['null-trashed'] || 0,
              scopedSlots: { title: 'title' },
              children: []
            },
            ...this.listToTree(res.data.items, 0, true)
          ];
          const total = children.reduce((sum, c) => sum + (c.total || 0), 0);
          const trashedTotal = trashedChildren.reduce((sum, c) => sum + (c.total || 0), 0);
          this.moduleData = [
            {
              id: -1,
              key: -1,
              title: '正常用例',
              name: '正常用例',
              total: total,
              scopedSlots: { title: 'title' },
              children: children
            },
            {
              id: -2,
              key: -2,
              title: '已废弃',
              name: '已废弃',
              total: trashedTotal,
              scopedSlots: { title: 'title' },
              children: trashedChildren
            }
          ];
          this.loading = false;
          if (this.expandedKeys.length === 0) {
            this.expandedKeys = this.moduleData.map(module => module.key);
          }
          this.moduleDataCopy = JSON.parse(JSON.stringify(this.moduleData));
          // 如果当前路由中有ModuleId筛选条件，则用例目录自动展开并定位该目录

          if (this.moduleId) {
            const currentModule = items.find(element => {
              return element.id === this.moduleId;
            });

            if (currentModule && currentModule.path) {
              currentModule.path.split(',').forEach(item => {
                this.expandedKeys.push(parseInt(item));
              });
            }
          }
          if (isInit && this.moduleData) {
            const node = this.getTreeData(this.moduleData, this.selectedKeys[0]);
            this.$emit('init', this.selectedKeys, node);
          }
        })
        .catch(() => {
          this.loading = false;
        });
    },
    getTreeData(treeData, key) {
      let nodeData = null;
      if (treeData && treeData.length > 0) {
        for (let i = 0; i < treeData.length; i++) {
          if (treeData[i].id === key) {
            nodeData = treeData[i];
            return nodeData;
          } else if (treeData[i].children && treeData[i].children.length > 0) {
            nodeData = this.getTreeData(treeData[i].children, key);
            if (nodeData != null) {
              return nodeData;
            }
          }
        }
      }
      return nodeData;
    }
  }
};
</script>

<style lang="less" scoped>
/deep/ .ant-card {
  margin-left: 16px;
  min-width: 304px;
  height: calc(~'100vh - 130px');
  float: left;

  .ant-card-body {
    padding: 8px;
    height: calc(~'100vh - 178px');
    overflow: auto;
  }
}

/deep/.ant-tree li {
  padding: 0px 0;
}

/deep/.ant-tree .ant-tree-show-line li {
  line-height: 28px;
}

/deep/.ant-tree.ant-tree-show-line li span.ant-tree-switcher {
  line-height: 28px;
}

/deep/.ant-tree li .ant-tree-node-content-wrapper {
  height: 28px;
  line-height: 28px;
}

// 自定义配置padding距离
/deep/ .ant-tree-node-content-wrapper-normal {
  display: block;
  line-height: 28px;
}

/deep/.ant-tree-child-tree > li:first-child {
  padding-top: 0px;
}

/deep/.ant-tree.ant-tree-show-line li:not(:last-child)::before {
  position: absolute;
  left: 12px;
  width: 1px;
  height: 100%;
  height: calc(90%);
  margin: 28px 0 0;
  border-left: 1px solid #d9d9d9;
  content: ' ';
}

.node-action {
  float: right;
  display: none;

  .icon-wrap {
    margin: 0 2px;
  }
}

.ant-tree-node-content-wrapper:hover {
  .node-action {
    display: inline;
  }
}

.shrink {
  margin-top: calc(~'50vh - 88px');
  width: 14px;
  height: 48px;
  border: 1px solid #e5e5e5;
  border-left: 0px;
  float: left;
  background-color: #fff;
  border-radius: 0 6px 6px 0;

  .shrink-icon {
    color: #e5e5e5;
    line-height: 48px;
    font-size: 12px;
    font-weight: bold;
  }
}

.shrink:hover {
  background-color: #1890ff;
  border: 1px solid #1890ff;

  .shrink-icon {
    color: #fff;
  }
}

.node-title_total {
  font-size: 12px;
  color: #bfbfbf;
  margin-left: 4px;
}
</style>
